export default __webpack_public_path__ + "static/media/img_muslinTwoEarsBib_rg_p.58c0c217.jpg";